import React from "react";
import { Link } from "react-router-dom";

export default function BusinessServiceShowcase({ content }) {
  return (
    <div id="businessServiceShowcase" className="businessServiceShowcase">
      <div className="contentContainer">
        <div className="content">
          <div className="serviceLeft">
            <div className="boxImage">
              <img src={content.image?.url} alt="imgShowcase" />
            </div>
          </div>
          <div className="serviceRight">
            <div className="subtitle">{content.subtitle}</div>
            <div className="title">{content.title}</div>
            <div className="richText" dangerouslySetInnerHTML={{ __html: content.richtext }} />
            <div className="btnService">
              <Link to={content.buttonLink}>{content.buttonText}</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
